import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'twitter-overlay',
  templateUrl: './twitter-overlay.component.html',
  styleUrls: ['./twitter-overlay.component.css']
})
export class TwitterOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
